import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import Tournaments from './pages/Tournaments'
import Settlements from './pages/Settlements'
import CashFlow from './pages/CashFlow'
import Players from './pages/Players'
import Levels from './pages/Levels'
import Sports from './pages/Sports'
import Clubs from './pages/Clubs'
import Suppliers from './pages/Suppliers'
import PurchaseDocuments from './pages/PurchaseDocuments'
import InventoryItems from './pages/InventoryItems'
import ProtectedRoute from './components/ProtectedRoute'
import ReportsInventoryBalances from './pages/ReportsInventoryBalances'
import ReportsInventoryMovements from './pages/ReportsInventoryMovements'
import ReportsSettlements from './pages/ReportsSettlements'
import ReportsPlayerSettlements from './pages/ReportsPlayerSettlements'
import PlayerPayments from './pages/PlayerPayments'
import ReportsCashMovements from './pages/ReportsCashMovements'
import ReportsProfitImpact from './pages/ReportsProfitImpact'
import ReportsProfit from './pages/ReportsProfit'
import TournamentControlReport from './pages/TournamentControlReport'
import ReportsCourtRentals from './pages/ReportsCourtRentals'
import Warehouses from './pages/Warehouses'
import PlayerCancellations from './pages/PlayerCancellations'
import PlayerDiscounts from './pages/PlayerDiscounts'
import PlayerLevelChangeDocuments from './pages/PlayerLevelChangeDocuments'
import ServicePurchases from './pages/ServicePurchases'
import ServicePurchaseNew from './pages/ServicePurchaseNew'
import InventoryConsumptions from './pages/InventoryConsumptions'
import InventoryReturns from './pages/InventoryReturns'
import InventoryReturnSettings from './pages/InventoryReturnSettings'
import InventorySales from './pages/InventorySales'
import InventoryTransfers from './pages/InventoryTransfers'
import SupplierPayments from './pages/SupplierPayments'
import CustomerPayments from './pages/CustomerPayments'
import ExpenseArticles from './pages/ExpenseArticles'
import CashExpenses from './pages/CashExpenses'
import CashAccounts from './pages/CashAccounts'
import CourtReservations from './pages/CourtReservations'
import BracketTemplates from './pages/BracketTemplates'
import Draws from './pages/Draws'
import TournamentStandings from './pages/TournamentStandings'
import MatchResults from './pages/MatchResults'
import MatchFormats from './pages/MatchFormats'
import PointsSystem from './pages/PointsSystem'
import PointsAccrualDocuments from './pages/PointsAccrualDocuments'
import RatingDocuments from './pages/RatingDocuments'
import MatchProposals from './pages/MatchProposals'
import TelegramLogs from './pages/TelegramLogs'
import Chat from './pages/Chat'
import TelegramSettings from './pages/TelegramSettings'
import TelegramGroupSettings from './pages/TelegramGroupSettings'
import TelegramScenarios from './pages/TelegramScenarios'
import TelegramModules from './pages/TelegramModules'
import TelegramAssistants from './pages/TelegramAssistants'
import TelegramNotifications from './pages/TelegramNotifications'
import TelegramPolls from './pages/TelegramPolls'
import TelegramContests from './pages/TelegramContests'
import TelegramRegistrationRequests from './pages/TelegramRegistrationRequests'
import TelegramBroadcasts from './pages/TelegramBroadcasts'
import StandingsExport from './pages/StandingsExport'
import ContestReportExport from './pages/ContestReportExport'
import Files from './pages/Files'
import SettingsUsers from './pages/SettingsUsers'
import SettingsUserEdit from './pages/SettingsUserEdit'
import ServerSettings from './pages/ServerSettings'
import PlaySettings from './pages/PlaySettings'
import PlayAdmin from './pages/PlayAdmin'
import MatchScoreEntrySettings from './pages/MatchScoreEntrySettings'
import PlatformIdentities from './pages/PlatformIdentities'
import PlatformIdentityDetail from './pages/PlatformIdentityDetail'
import './App.css'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/tournaments" element={
          <ProtectedRoute>
            <Layout>
              <Tournaments />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/settlements" element={
          <ProtectedRoute>
            <Layout>
              <Settlements />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/cashflow" element={
          <ProtectedRoute>
            <Layout>
              <CashFlow />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/players" element={
          <ProtectedRoute>
            <Layout>
              <Players />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/identities" element={
          <ProtectedRoute>
            <Layout>
              <PlatformIdentities />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/identities/:id" element={
          <ProtectedRoute>
            <Layout>
              <PlatformIdentityDetail />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/levels" element={
          <ProtectedRoute>
            <Layout>
              <Levels />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/sports" element={
          <ProtectedRoute>
            <Layout>
              <Sports />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/clubs" element={
          <ProtectedRoute>
            <Layout>
              <Clubs />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/suppliers" element={
          <ProtectedRoute>
            <Layout>
              <Suppliers />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/purchases" element={
          <ProtectedRoute>
            <Layout>
              <PurchaseDocuments />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/inventory-items" element={
          <ProtectedRoute>
            <Layout>
              <InventoryItems />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/inventory-balances" element={
          <ProtectedRoute>
            <Layout>
              <ReportsInventoryBalances />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/inventory-movements" element={
          <ProtectedRoute>
            <Layout>
              <ReportsInventoryMovements />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/settlements" element={
          <ProtectedRoute>
            <Layout>
              <ReportsSettlements />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/player-settlements" element={
          <ProtectedRoute>
            <Layout>
              <ReportsPlayerSettlements />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/documents/player-payments" element={
          <ProtectedRoute>
            <Layout>
              <PlayerPayments />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/documents/player-cancellations" element={
          <ProtectedRoute>
            <Layout>
              <PlayerCancellations />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/documents/player-discounts" element={
          <ProtectedRoute>
            <Layout>
              <PlayerDiscounts />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/documents/player-level-changes" element={
          <ProtectedRoute>
            <Layout>
              <PlayerLevelChangeDocuments />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/cash-movements" element={
          <ProtectedRoute>
            <Layout>
              <ReportsCashMovements />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/profit-impact" element={
          <ProtectedRoute>
            <Layout>
              <ReportsProfitImpact />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/profit" element={
          <ProtectedRoute>
            <Layout>
              <ReportsProfit />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/tournaments-control" element={
          <ProtectedRoute>
            <Layout>
              <TournamentControlReport />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/reports/court-rentals" element={
          <ProtectedRoute>
            <Layout>
              <ReportsCourtRentals />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/warehouses" element={
          <ProtectedRoute>
            <Layout>
              <Warehouses />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/service-purchases" element={
          <ProtectedRoute>
            <Layout>
              <ServicePurchases />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/service-purchases/new" element={
          <ProtectedRoute>
            <Layout>
              <ServicePurchaseNew />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/inventory-consumptions" element={
          <ProtectedRoute>
            <Layout>
              <InventoryConsumptions />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/inventory-returns" element={
          <ProtectedRoute>
            <Layout>
              <InventoryReturns />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/inventory-sales" element={
          <ProtectedRoute>
            <Layout>
              <InventorySales />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/inventory-transfers" element={
          <ProtectedRoute>
            <Layout>
              <InventoryTransfers />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/inventory-return-settings" element={
          <ProtectedRoute>
            <Layout>
              <InventoryReturnSettings />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/supplier-payments" element={
          <ProtectedRoute>
            <Layout>
              <SupplierPayments />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/customer-payments" element={
          <ProtectedRoute>
            <Layout>
              <CustomerPayments />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/expense-articles" element={
          <ProtectedRoute>
            <Layout>
              <ExpenseArticles />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/cash-expenses" element={
          <ProtectedRoute>
            <Layout>
              <CashExpenses />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/cash-accounts" element={
          <ProtectedRoute>
            <Layout>
              <CashAccounts />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/court-reservations" element={
          <ProtectedRoute>
            <Layout>
              <CourtReservations />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/bracket-templates" element={
          <ProtectedRoute>
            <Layout>
              <BracketTemplates />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/draws" element={
          <ProtectedRoute>
            <Layout>
              <Draws />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/tournament-standings" element={
          <ProtectedRoute>
            <Layout>
              <TournamentStandings />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/standings-export/:tournamentId/:level" element={<StandingsExport />} />
        <Route path="/contest-export/:contestId" element={<ContestReportExport />} />
        <Route path="/match-results" element={
          <ProtectedRoute>
            <Layout>
              <MatchResults />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/match-formats" element={
          <ProtectedRoute>
            <Layout>
              <MatchFormats />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/points-system" element={
          <ProtectedRoute>
            <Layout>
              <PointsSystem />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/points-accrual-documents" element={
          <ProtectedRoute>
            <Layout>
              <PointsAccrualDocuments />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/rating-documents" element={
          <ProtectedRoute>
            <Layout>
              <RatingDocuments />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/match-proposals" element={
          <ProtectedRoute>
            <Layout>
              <MatchProposals />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/logs" element={
          <ProtectedRoute>
            <Layout>
              <TelegramLogs />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/chat" element={
          <ProtectedRoute>
            <Layout>
              <Chat />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/settings" element={
          <ProtectedRoute>
            <Layout>
              <TelegramSettings />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/groups" element={
          <ProtectedRoute>
            <Layout>
              <TelegramGroupSettings />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/scenarios" element={
          <ProtectedRoute>
            <Layout>
              <TelegramScenarios />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/modules" element={
          <ProtectedRoute>
            <Layout>
              <TelegramModules />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/assistants" element={
          <ProtectedRoute>
            <Layout>
              <TelegramAssistants />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/notifications" element={
          <ProtectedRoute>
            <Layout>
              <TelegramNotifications />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/polls" element={
          <ProtectedRoute>
            <Layout>
              <TelegramPolls />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/contests" element={
          <ProtectedRoute>
            <Layout>
              <TelegramContests />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/registration-requests" element={
          <ProtectedRoute>
            <Layout>
              <TelegramRegistrationRequests />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/telegram/broadcasts" element={
          <ProtectedRoute>
            <Layout>
              <TelegramBroadcasts />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/files" element={
          <ProtectedRoute>
            <Layout>
              <Files />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/settings/users" element={
          <ProtectedRoute>
            <Layout>
              <SettingsUsers />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/settings/users/:userId" element={
          <ProtectedRoute>
            <Layout>
              <SettingsUserEdit />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/settings/server" element={
          <ProtectedRoute>
            <Layout>
              <ServerSettings />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/settings/play" element={
          <ProtectedRoute>
            <Layout>
              <PlaySettings />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/settings/match-score-entry" element={
          <ProtectedRoute>
            <Layout>
              <MatchScoreEntrySettings />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/play/admin" element={
          <ProtectedRoute>
            <Layout>
              <PlayAdmin />
            </Layout>
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  )
}

export default App
